// src/Layouts/TechnicianLayout.jsx
import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import TechnicianSidebar from "../components/technician/TechnicianSidebar";

const TechnicianLayout = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  useEffect(() => {
    setSidebarOpen(!isMobile);
  }, [isMobile]);

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f8f9fa" }}>
      <TechnicianSidebar
        isOpen={sidebarOpen}
        isMobile={isMobile}
        onSidebarToggle={setSidebarOpen}
        logout={handleLogout}
        currentUser={currentUser}
      />
      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,
          p: { xs: 2, md: 3 },
          mt: { xs: 7, md: 0 }, // clear the mobile FAB
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default TechnicianLayout;